<template>
    <div class="page bg-blue relative desktop-footer">
         <div class="bg-head-coin"></div>
        <div class="page-content sm:px-8">
            <TopBar title="mission" :isShowOnlyLogo="true" :modalController="modalController"></TopBar>
            <div class="px-2 mt-7">
                <LoginMobile :modalController="modalController"></LoginMobile>
            </div>
            <MenuDesktop activeMenu="mission"></MenuDesktop>
            <div class="bg-white py-6 mt-4 rounded-25 mx-2" v-if="missionList.length">
                <MissionList :missionList="missionList"></MissionList>
                <div class="mt-5">
                    <div class="width-menu mx-2 fixed left-0 bottom-0 bg-white pb-4 px-2 rounded-b-25">
                        <MenuMobile activeMenu="mission" />
                    </div>
                </div>
            </div>
            <div v-else-if="isLoaded && !missionList.length" class="bg-white py-6 mt-4 rounded-25 mx-2 h-400px">
                <div class="mt-14">
                    <img class="img-warning m-auto" src="@/assets/icon/warning-icon.png">
                    <div class="text-center text-a-blue-1c3e95 text-20 mt-3">{{lbl.home.no_data}}</div>
                </div>
            </div>
        </div>
        <BottomBar></BottomBar>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>

//component
import BottomBar from '../../../components/Layout/BottomBar/BottomBar.vue';
import MenuMobile from '@/components/Layout/MenuMobile/MenuMobile.vue';
import MissionList from '../component/MissionList.vue';
import LoginMobile from '@/components/Layout/LoginMobile/LoginMobile.vue';
import TopBar from '@/components/Layout/TopBar/TopBar.vue';
import MenuDesktop from '@/components/Layout/MenuDesktop/MenuDesktop.vue';
//service
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";

//mixin
import ModalMixin from "@/mixin/ModalMixin.js";
import LocaleMixin from '@/mixin/LocaleMixin';

export default({
    name: 'mission',
    mixins: [ModalMixin, LocaleMixin],
    components: {
        BottomBar,
        MenuMobile,
        MissionList,
        LoginMobile,
        TopBar,
        MenuDesktop
    },
    data: function() {
        return {
            missionList: [],
            isLoaded: false,
        }
    },
    created: function() {
    },
    mounted: function () {
        this.getMission();

    },
    methods: {
        getMission: function() {
            this.loadingModal.show();
            this.isLoaded = false
            return new Promise((resolve) => {
                BzbsProfile.getMissionList()
                    .subscribe ({
                        next: (mission) => {
                            this.missionList = mission;
                            this.loadingModal.hide();
                            this.isLoaded = true
                            resolve();
                        },
                        error: (err) => {
                            resolve();
                            this.loadingModal.hide();
                            this.isLoaded = true
                            this.errorApi(err);
                        }
                    })
            });
        },
    }
})
</script>
<style land="scss">
.width-menu {
    width: calc(100% - 16px);
}
</style>
